module.exports = __webpack_public_path__ + "static/img/logo2.feb547d6.png";